import { IAmount } from './amount'
import { IApplicationValidation } from './application-validation.interface'
import { ICourse } from './course'
import { IUser } from './user'

export interface IContractChoices {
  fixedNumberOfInstalments?: number
  courseStartDate?: string
  courseLocation?: string
  preferredPaymentDay?: number
}

export interface IApplicationData {
  contractChoices?: IContractChoices
}

export type PaymentTypeOption =
  | 'CREDIT_CARD'
  | 'RETRIBUICION_FLEXIBLE'
  | 'FIXPAY'

export interface IApplicationSteps {
  shouldEducationProviderValidate: boolean
  shouldEmployerValidate: boolean
  shouldFlexibleRemunerationValidate: boolean
}

export enum ApplicationStatus {
  Applied = 'APPLIED',
  PendingContract = 'PENDING_CONTRACT',
  ContractSigned = 'CONTRACT_SIGNED',
  MissingScoringData = 'MISSING_SCORING_DATA',
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  PendingValidation = 'PENDING_VALIDATION',
  Complete = 'COMPLETE',
  Cancelled = 'CANCELLED',
}

export interface IApplication {
  _id?: string
  user: string | IUser
  course: string | ICourse
  cohort: string
  flexibleRemuneration: boolean
  applicationTerm: ApplicationTerm
  statuses?: ApplicationStatus[]
  applicationData?: IApplicationData
  applicationSteps?: IApplicationSteps
  learningBudget?: IAmount
  checkoutUrl?: string
  validations?: IApplicationValidation[]
  createdAt?: string
  updatedAt?: string
}

export interface IApplicationsFilter {
  userId?: string
  courseId?: string
  isRejected?: boolean
}

export enum ApplicationTerm {
  Upfront = 'UPFRONT',
  FixPay = 'FIXPAY',
  Isa = 'ISA',
  Elsa = 'ELSA',
  Free = 'FREE',
}
